import L from "leaflet";
import PlaceOfHome from "!!raw-loader!../assets/icons/place-of-home.svg";
import Circle from "!!raw-loader!../assets/icons/circle.svg";
import Center from "!!raw-loader!../assets/icons/center.svg";
import SubCenter from "!!raw-loader!../assets/icons/sub-center.svg";
import Frankfurt from "!!raw-loader!../assets/icons/frankfurt.svg";
import Memorial from "!!raw-loader!../assets/icons/memorial.svg";

const icon = (svg, color, iconSize, className = "") =>
  L.divIcon({
    html: `<span style="color: ${color}">${svg}</span>`,
    iconSize,
    className: `icon ${className}`,
  });

export default {
  circle: (color = "var(--color-gamma)") => icon(Circle, color, 10),
  house: () => icon(PlaceOfHome, null, 20, "house-icon"),
  center: () => icon(Center, null, 25, "center-icon"),
  subCenter: () => icon(SubCenter, null, 10, "center-icon"),
  frankfurt: () => icon(Frankfurt, null, 25, "center-icon"),
  memorial: () => icon(Memorial, null, 20, "memorial-icon"),
};
